<script>
import vSelect from 'vue-select'
import {BCard, BCardTitle, BFormGroup, BTable} from 'bootstrap-vue'
import LegalRoleBusinessRole from "@/views/administration/legislation/components/LegalRoleBusinessRole.vue";
import {i18nApi, SupplyChain} from "@core/api";
import {Button} from "@core/components/common";
import ManageLegalRoleModal from "@/views/administration/legislation/components/ManageLegalRoleModal.vue";

export default {
    components: {vSelect, BCard, BCardTitle, BFormGroup, LegalRoleBusinessRole, BTable, Button, ManageLegalRoleModal},
    props: {
        legalRoles: {
            required: true
        },
        legalRoleBusinessRoles: {
            default() {
                return []
            }
        }
    },
    data() {
        return {
            languages: [],
            options: [],
            lr: this.legalRoles,
            lrFields: [
                { key: 'id', label: this.$t('Component(Grid):column-id') },
                { key: 'title', label: this.$t('Component(Grid):column-name') },
                { key: 'actions', label: this.$t('Component(Grid):column-actions'), class: 'text-right' },
            ],

            businessRoles: [],
            editableLegalRole: null
        }
    },
    methods: {
        removeLegalRole(role) {
            this.$emit('remove', role);
        },
        addLegalRole() {
            this.editableLegalRole = {
                __new: true,
                id: 'new-' + (new Date()).getTime(),
                title: '',
                translations: {}
            };
            this.languages.forEach(language => {
                this.editableLegalRole.translations[language.code] = {title: ''}
            });

            this.$refs.manageLegalRoleModal.show();
        },
        saveLegalRole() {
            this.editableLegalRole.title = this.editableLegalRole.translations.en.title;
            this.$emit('saveLegalRole', this.editableLegalRole);
        },
        modalClosed() {
            this.editableLegalRole = null;
        },
        onLegalRoleRowClick(legalRole) {
            this.editableLegalRole = {
                ...legalRole,
                translations: {}
            };
            Object.keys(legalRole.translations).map(language => {
                this.editableLegalRole.translations[language] = {
                    title: legalRole.translations[language].title
                };
            });
            this.$refs.manageLegalRoleModal.show();
        },
        onBusinessRolesChanged(legalRoleBusinessRole, businessRoles) {
            this.$emit('businessRolesChanged', legalRoleBusinessRole, businessRoles);
        }
    },
    watch: {
        legalRoles() {
            this.lr = this.legalRoles;
        }
    },
    created() {
        i18nApi.getLanguages().then(r => {
            this.languages = r.data
        });
        SupplyChain.getBusinessRoles().then(r => this.businessRoles = r.data);
    },
}
</script>

<template>
    <div>
        <ManageLegalRoleModal
            ref="manageLegalRoleModal"
            :legal-role="editableLegalRole"
            @save="saveLegalRole"
            @modalClosed="modalClosed"
        />

        <b-card no-body>
            <div class="card-header">
                <div class="col-md-12 pl-0">
                    <b-card-title>
                        {{ $t('Component(Text):legal-roles-management') }}
                    </b-card-title>
                </div>
            </div>
            <div class="pl-2 pr-2 pb-1">
                <b-card no-body border-variant="light">
                    <div class="card-header">
                        <div class="col-md-6 pl-0">
                            <b-card-title>
                                {{ $t('Component(Text):legal-roles') }}
                            </b-card-title>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <Button class="btn-icon" @click="addLegalRole">
                                    <feather-icon icon="PlusIcon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <b-table
                        hover
                        :fields="lrFields"
                        :items="lr"
                        responsive="sm"
                        @row-clicked="onLegalRoleRowClick"
                    >
                        <template #cell(actions)="data">
                            <Button
                                class="btn-icon"
                                variant="danger"
                                @click="removeLegalRole(data.item)"
                            >
                                <feather-icon icon="Trash2Icon"/>
                            </Button>
                        </template>
                    </b-table>
                </b-card>

                <b-card no-body border-variant="light">
                    <div class="card-header">
                        <div class="col-md-12 pl-0">
                            <b-card-title>
                                {{ $t('Component(Text):legal-roles-business-roles') }}
                            </b-card-title>
                        </div>
                    </div>
                    <div class="pl-2 pr-2 pb-1">
                        <LegalRoleBusinessRole
                            v-for="legalRole in legalRoleBusinessRoles"
                            :role="legalRole"
                            @input="onBusinessRolesChanged"
                        />
                    </div>
                </b-card>
            </div>
        </b-card>
    </div>
</template>
